import createYearTabsListingView from '../PeriodTabs/createYearTabsListingView';
import FlexTalkCard from './FlexTalkCard';

export default createYearTabsListingView(FlexTalkCard, {
  displayName: 'TalkYearTabsView',
  containerClass: '',
  supportsGrid: true,
  hideLinkByDefault: false,
});
